<template>
    <div class="share-btns">
        <i @click="share('facebook')" :data-id="id" class="fab fa-facebook" data-label="Facebook" />
        <i @click="share('whatsapp')" :data-id="id" class="fab fa-whatsapp" data-label="Whatsapp" />
        <i @click="share('email')" :data-id="id" class="far fa-envelope" data-label="Email" />
        <i @click="share('copy')" :data-id="id" class="fas fa-link" data-label="Link" />
</div>
</template>
<script>
import commonFunc from '~/assets/js/commonHelper.js'
export default {
  name: "Share",
  props: {
    title: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    this.url = window.location.href
  },
  methods: {
    share: function (type) {
      const shareTitle = this.title + ' | MoneyPlaza'
      const shareUrl = this.url
      switch (type) {
        case 'facebook':
          const shareSubject = shareTitle
          const shareContent = this.t('share.fb_content', { link: shareUrl })
          const faceLink = 'http://www.facebook.com/sharer.php?u=' + encodeURIComponent(shareContent) + '&t=' + encodeURIComponent(shareSubject)
          window.open(faceLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=620,height=548')
          break
        case 'whatsapp':
          const shareText = this.t('share.whatsapp', { title: shareTitle, link: shareUrl })
          const link = 'https://wa.me?text=' + encodeURIComponent(shareText)
          window.open(link, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=620,height=548')
          break
        case 'email':
          const emailSubject = this.t('share.email_subject', { title: shareTitle })
          const emailContent = this.t('share.email_content', { link: shareUrl })
          window.location.assign('mailto:?Subject=' + decodeURIComponent(emailSubject) + '&body=' + decodeURIComponent(emailContent))
          break
        case 'copy':
          const tempInput = document.createElement('input')
          tempInput.style = 'position: fixed; left: -1000px; top: -1000px'
          tempInput.value = this.url
          document.body.appendChild(tempInput)
          tempInput.select()
          document.execCommand('copy')
          document.body.removeChild(tempInput)
          commonFunc.toast(this.t('blog.copied'), 'success')
          break
      }
    }
  }
};
</script>